export default __webpack_public_path__ + "static/media/career-thumbnail-placeholder.b18a400c.jpg";